import React from "react";

import Form from "@Components/Form";
import { URLS, STATE_URL } from "configs/constants";

const initialValues = {
  state: "",
  name: "",
  active: true,
};

const StateForm = () => {
  let formFields = [
    {
      type: "input",
      name: "name",
      label: "Name",
      required: true,
      gridSize: { xs: 12, sm: 8, md: 9, lg: 6 },

    },
    
    {
      name: "active",
      type: "switch",
      label: "Status",
      color: "primary",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 6 },


    },
  ];

  const formButtons = [
    {
      type: "submit",
      label: "Submit",
      color: "primary",
    },
    {
      type: "reset",
      label: "Reset",
    },
  ];

  // let module = getAssignedModule(location.pathname);
  // let actionPermission = false;
  // if (!module || module === "") {
  //   actionPermission = true;
  // } else {
  //   let updatedModules = JSON.parse(
  //     localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES)
  //   );
  //   if (updatedModules[module]) {
  //     let modulePermissions = updatedModules[module].map((perm) => {
  //       if (typeof perm === "string") {
  //         return perm.toLowerCase();
  //       }
  //       return perm;
  //     });
  //     if (modulePermissions.includes("change status")) {
  //       actionPermission = true;
  //     }
  //   }
  // }
  // if (actionPermission) {
  //   formFields.push({
  //     type: "switch",
  //     name: "active",
  //     label: "Active?",
  //     required: true,
  //     nolabel: "No",
  //     yeslabel: "Yes",
  //   });
  // }

  return (
    <Form
      initialValues={initialValues}
      submitUrl={STATE_URL}
      listRoute={URLS.STATE_CUSTOM_FIELDS}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="State"
    />
  );
};

export default StateForm;
